import React from "react";
import { 
  BodyCard,
  TitleLocalization,
  HeadCard,
  BottomCard,
  StyledPopup} from "./style";
import { useSelector } from "react-redux";
import { RootState } from "../../redux/reducers/index";
import { Close } from "../MainModal/Close";
import { Card } from '../../theme/theme'
import ModalButton from '../ModalButton'
import { CustomIcon } from '../CustomIcon'
import {formatNameCity} from '../../utils/formatData'
import { language } from "../../utils/language";

const AlertLocalizationModal = (props: any) => {
    const elogisticaState: any = useSelector((state: RootState) => state.elogistica)
    const homeState: any = useSelector((state: RootState) => state.home)
    const { refData, color, mode, showModalLocalization } = props;

    return (
        <>
            <StyledPopup ref={refData}
                trigger={
                    <div>
                        {mode === "mobile" ?
                            <CustomIcon color={'#000000'} hover={false} type="localization" />
                            : <TitleLocalization>{formatNameCity(elogisticaState.selectedCity.nombre)}</TitleLocalization>
                        }
                    </div>
                } position="bottom center" className="containerPopup">
                {(close: any) => (
                    <Card>
                        <HeadCard {...props}>
                            <div>
                                {language[homeState.default_language]["optionSend"]}
                            </div> 
                            <Close onClick={close} color={color}>
                                {" "}
                            </Close>
                        </HeadCard>      
                        <BodyCard>
                            {language[homeState.default_language]["messageDelivery"]}      
                        </BodyCard>
                        <BottomCard>
                            <ModalButton color={color} secondary={false} onClick={() => { refData.current.close(); showModalLocalization() }}>{language[homeState.default_language]["changeLocation"]}</ModalButton>
                            <ModalButton color={color} secondary={true} className='ml-2' onClick={close}>{language[homeState.default_language]["maintainLocation"]}</ModalButton>
                        </BottomCard>
                    </Card>
                )}
            </StyledPopup>
        </>
    );
};

export default AlertLocalizationModal;
